import React from 'react';
import { useContext } from 'react';
import './../assets/css/Pages.css';
import { Routes, Route } from 'react-router-dom';
import Manuals from '../pages/Manuals';
import Home from '../pages/Home';
import AddPost from '../pages/AddPost';
import Posts from '../pages/Posts';
import Missing from '../pages/Missing';
import Settings from '../pages/Settings';
import Post from '../pages/Post';
import UserProfile from '../pages/userProfile/UserProfile';
import PublicSubmission from '../pages/unprocessed/PublicSubmission';
import SMS from '../pages/unprocessed/SMS';
import MonitorSubmission from '../pages/unprocessed/MonitorSubmission';
import DiscardedIncidents from '../pages/processed/DiscardedIncidents';
import InvalidIncidents from '../pages/processed/InvalidIncidents';
import ValidIncidents from '../pages/processed/ValidIncidents';
import NewIncident from '../pages/NewIncident';
import Notifications from '../pages/Notifications';
import Users from '../pages/settings/Users';
import Roles from '../pages/settings/Roles';
import BroadCategories from '../pages/settings/BroadCategories';
import Categories from '../pages/settings/Categories';
import SubCategories from '../pages/settings/SubCategories';
import Rights from '../pages/settings/Rights';
import Issues from '../pages/settings/Issues';
import Religions from '../pages/settings/Religions';
import Tribes from '../pages/settings/Tribes';
import MaritalStatuses from '../pages/settings/MaritalStatuses';
import MarriageTypes from '../pages/settings/MarriageTypes';
import Vulnerabilities from '../pages/settings/Vulnerabilities';
import Disabilities from '../pages/settings/Disabilities';
import Countries from '../pages/settings/Countries';
import Zones from '../pages/settings/Zones';
import Regions from '../pages/settings/Regions';
import Districts from '../pages/settings/Districts';
import Wards from '../pages/settings/Wards';
import EmploymentStatuses from '../pages/settings/EmploymentStatuses';
import ManualsSettings from '../pages/settings/ManualsSettings';
import IncidentStatuses from '../pages/settings/IncidentStatuses';
import MonitorsIncidentsPerZone from '../pages/reports/MonitorsIncidentsPerZone';
import MonitorsIncidentsPerUser from '../pages/reports/MonitorsIncidentsPerUser';
import MonitorsIncidentsPerRegion from '../pages/reports/MonitorsIncidentsPerRegion';
import MonitorsIncidentsPerDistrict from '../pages/reports/MonitorsIncidentsPerDistrict';
import GeneralIncidentsPerZone from '../pages/reports/GeneralIncidentsPerZone';
import GeneralIncidentsPerRegion from '../pages/reports/GeneralIncidentsPerRegion';
import GeneralIncidentsPerDistrict from '../pages/reports/GeneralIncidentsPerDistrict';
import ValidIncidentsPerBroadCategory from '../pages/reports/ValidIncidentsPerBroadCategory';
import ValidIncidentsPerCategory from '../pages/reports/ValidIncidentsPerCategory';
import ValidIncidentsPerRight from '../pages/reports/ValidIncidentsPerRight';
import ValidIncidentsPerSubCategory from '../pages/reports/ValidIncidentsPerSubCategory';
import HomeMonitor from '../pages/HomeMonitor';
import DataContext from '../context/DataContext';
import IncidentResponseStatuses from '../pages/settings/IncidentResponseStatuses';
import ValidIncidentsPerSex from '../pages/reports/ValidIncidentsPerSex';
import ValidIncidentsPerDisability from '../pages/reports/ValidIncidentsPerDisability';
import ValidIncidentsPerVulnerability from '../pages/reports/ValidIncidentsPerVulnerability';
import ValidIncidentsPerAgeGroup from '../pages/reports/ValidIncidentsPerAgeGroup';
import ValidIncidentsPerStatus from '../pages/reports/ValidIncidentsPerStatus';
import ValidIncidentsPerResponseStatus from '../pages/reports/ValidIncidentsPerResponseStatus';
import ResponsesTable from '../pages/reports/ResponsesTable';
import FollowupsTable from '../pages/reports/FollowupsTable';









const Pages = () => {


  const { auntheticatedUser} = useContext(DataContext);

  const lhrcinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false
  
  



  return (
    <div className='pages'>
      <Routes>
        <Route path='/'>
          <Route index element={lhrcinitiated? <Home /> : <HomeMonitor />} />
          {/* <Route path='homeMonitor' element={<HomeMonitor />} /> */}
          <Route path='addpost' element={<AddPost />} />
          <Route path='newincident' element={<NewIncident />} />
          <Route path='notifications' element={<Notifications />} />
          <Route path='post/:id' element={<Post />} />
          <Route path='posts' element={<Posts />} />
          <Route path='manuals' element={<Manuals />} />

          <Route path='settings' element={<Settings />} >
            <Route index element={<Users />} />
            <Route path='users' element={<Users />} />
            <Route path='roles' element={<Roles />} />
            <Route path='broadcategories' element={<BroadCategories />} />
            <Route path='categories' element={<Categories />} />
            <Route path='subcategories' element={<SubCategories />} />
            <Route path='incidentstatuses' element={<IncidentStatuses />} />
            <Route path='incidentresponsestatuses' element={<IncidentResponseStatuses />} />
            <Route path='rights' element={<Rights />} />
            <Route path='issues' element={<BroadCategories />} />
            <Route path='religions' element={<Religions />} />
            <Route path='tribes' element={<Tribes />} />
            <Route path='maritalstatuses' element={<MaritalStatuses />} />
            <Route path='employmentstatuses' element={<EmploymentStatuses />} />
            <Route path='marriagetypes' element={<MarriageTypes />} />
            <Route path='vulnerabilities' element={<Vulnerabilities />} />
            <Route path='disabilities' element={<Disabilities />} />
            <Route path='countries' element={<Countries />} />
            <Route path='zones' element={<Zones />} />
            <Route path='regions' element={<Regions />} />
            <Route path='districts' element={<Districts />} />
            <Route path='wards' element={<Wards />} />
            <Route path='manualssettings' element={<ManualsSettings />} />
          </Route>

          <Route path='userprofile' element={<UserProfile />} />
          <Route path='smsSubmission' element={<SMS />} />
          <Route path='publicSubmission' element={<PublicSubmission />} />
          <Route path='monitorSubmission' element={<MonitorSubmission />} />
          <Route path='validIncidents' element={<ValidIncidents />} />
          <Route path='invalidIncidents' element={<InvalidIncidents />} />
          <Route path='discardedIncidents' element={<DiscardedIncidents />} />
          <Route path='inc-mnt-zone' element={<MonitorsIncidentsPerZone />} />
          <Route path='inc-mnt-region' element={<MonitorsIncidentsPerRegion />} />
          <Route path='inc-mnt-district' element={<MonitorsIncidentsPerDistrict />} />
          <Route path='inc-mnt-user' element={<MonitorsIncidentsPerUser />} />
          <Route path='inc-zone' element={<GeneralIncidentsPerZone />} />
          <Route path='inc-region' element={<GeneralIncidentsPerRegion />} />
          <Route path='inc-district' element={<GeneralIncidentsPerDistrict />} />
          <Route path='val-inc-broadcategory' element={<ValidIncidentsPerBroadCategory/>} />
          <Route path='val-inc-category' element={<ValidIncidentsPerCategory />} />
          <Route path='val-inc-subcategory' element={<ValidIncidentsPerSubCategory />} />
          <Route path='val-inc-right' element={<ValidIncidentsPerRight />} />
          <Route path='val-inc-sexvictim' element={<ValidIncidentsPerSex />} />
          <Route path='val-inc-disability' element={<ValidIncidentsPerDisability />} />
          <Route path='val-inc-vulnerability' element={<ValidIncidentsPerVulnerability />} />
          <Route path='val-inc-agegroup' element={<ValidIncidentsPerAgeGroup />} />
          <Route path='val-inc-status' element={<ValidIncidentsPerStatus />} />
          <Route path='val-inc-responsestatus' element={<ValidIncidentsPerResponseStatus />} />
          <Route path='rpt-responses' element={<ResponsesTable />} />
          <Route path='rpt-followups' element={<FollowupsTable />} />
        </Route>
        <Route path='*' element={<Missing />} />
      </Routes>
    </div>
  );
};

export default Pages;
